import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { Tooltip } from '@arkestro/arkestro-design-system';

interface GetRendererWithIconParams {
  className?: string;
  icon?: ReactNode;
  name: string;
  tooltip?: string;
  wrapper: HTMLElement;
}

export const getRendererWithIcon = ({ className, icon, name, tooltip, wrapper }: GetRendererWithIconParams): HTMLElement => {
  const container = document.createElement('div');

  createRoot(container).render(
    <Tooltip title={tooltip}>
      {!icon ? '' : icon}{' '}{name}
    </Tooltip>
  );
  const updatedWrapper = wrapper;

  updatedWrapper.className = className?.length ? className : wrapper.className;
  updatedWrapper.innerHTML = '';
  updatedWrapper.appendChild(container);
  updatedWrapper.classList.add('arkestro-custom-dropdown-menu-item-hook');

  return updatedWrapper;
};
